/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        slug: {
    type: 'string',
    isRequired: true,
},
        departmentId: {
    type: 'number',
    isNullable: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        questionType: {
    type: 'Enum',
    isRequired: true,
},
        isRequired: {
    type: 'boolean',
    isRequired: true,
},
        order: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        subTitle: {
    type: 'string',
    isRequired: true,
},
        options: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestionOption',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};